import { render } from "./activity-detail.vue?vue&type=template&id=623259a4&ts=true"
import script from "./activity-detail.vue?vue&type=script&lang=ts"
export * from "./activity-detail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__